import { currentDirection } from "@app/lib/helper";
import { useInViewSSR } from "@design-system/hooks";
import { currentIndexAtom, projectsAtom } from "@modules/home/atoms";
import { ProjectCard } from "@modules/home/components";
import { motion } from "framer-motion";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export function ProjectsList() {
  const projects = projectsAtom.useValue();
  const dir = currentDirection();
  const { ref: containerRef, isInView } = useInViewSSR<HTMLDivElement>({
    once: true,
    margin: "-100px",
  });

  return (
    <div ref={containerRef} className="relative overflow-hidden lg:col-span-8 ">
      <motion.div
        initial={{ x: dir === "rtl" ? "200%" : "-200%" }}
        animate={isInView ? { x: 0 } : {}}
        transition={{ duration: 1.2, ease: "linear" }}
        className="relative overflow-hidden"
      >
        <Swiper
          className="w-full"
          spaceBetween={16}
          slidesPerView={1.3}
          key={dir}
          dir={dir}
          modules={[Navigation]}
          navigation={{
            nextEl: ".projects-button-next",
            prevEl: ".projects-button-prev",
          }}
          onSlideChange={(swiper) => {
            currentIndexAtom.update(swiper.activeIndex);
          }}
          breakpoints={{
            360: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 24,
            },
            1536: {
              slidesPerView: 3.3,
              spaceBetween: 32,
            },
          }}
        >
          {projects.map((project) => (
            <SwiperSlide key={project.id}>
              <ProjectCard project={project} />
            </SwiperSlide>
          ))}
        </Swiper>
      </motion.div>
    </div>
  );
}
